(function($) {
  $(document).ready(function() {
    engo.init();
    currency_div();
    sale_price();
    
  }); 

  function currency_div(){
    var cur = $('select.currency-picker');
    
    cur.parent().append('<div class="sub-curency"><ul class="currency-picker" name="currency-picker"></ul></div>');
    cur.parent().append('<a class="currency-label" href="#" title=""></a>');
    cur.css('display','none');

    $('.currency-label').html($('select.currency-picker').val());
    $('.currency-picker option').each(function(){
      $('.currency-picker').append('<li value="' + $(this).val() + '">'+$(this).text()+'</li>');
    });

    $('ul.currency-picker li').click(function(){
      var val =$(this).attr('value');
      cur.val(val).change();   
      $('.currency-label').html(val);
    })    
  }
  function sale_price(){
    $('.product-label.sale').each(function(){
      var price1 = $(this).attr('data-price1');
      var price2 = $(this).attr('data-price2');
      var sale =((price2 - price1)/price2)*100 ;
      var n = parseFloat(sale); 
      sale = Math.round(n);
      sale = '-' +sale+ '%';
      $(this).find('span').html(sale);
    });

  }
  function new_label(){
    $('.product .product-inner').each(function(){

      var pubDate = $(this).data("publish-date");
      var pubDate2=pubDate.substr(0, 10);
      var todayDate = new Date();
      var time1 = Date.parse(pubDate2);
      var time2 = Date.parse(todayDate);
      var time= Math.abs(time2 - time1);
      var a= 30*24*60*60*1000;

      if(time < a){
        $('.product .product-inner .new').show();

      }
    });
  }


  $(document).on('click','.overlay,.continue-shopping, .close-window', function() {   
    hidePopup('.engo-popup'); 

    setTimeout(function(){
      $('.loading').removeClass('loaded-content');
    },500);
    return false;
  });

  $('.dropdown-toggle').click(function() {
    $('.dropdown-content').removeClass('active');
    $(this).next().toggleClass('active');    
    return false;              
  });  

  var engo = { 
    init: function() {
      this.initHideDropdown();
      this.initToggle(); 


      this.initDropDownCart();

      this.initProductAddToCart();

    },

    /* Hide Dropdown */
    initHideDropdown: function(){
      $(document).on('click touchstart', function(e) {
        var mobileMenu = $(".main-menu");
        var topCart = $(".topCart");
        var dropdown = $(".dropdown-content");
        if (!mobileMenu.is(e.target) && mobileMenu.has(e.target).length === 0 && !topCart.is(e.target) && topCart.has(e.target).length === 0 && !dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
          mobileMenu.removeClass('active');
          topCart.removeClass('active');
          dropdown.removeClass('active');      
        }
      });
    },


    /* Dropdown Toggle */
    initToggle: function(){
      $('.caret').click(function() {        
        $(this).parent().next().toggleClass('active');        
        return false; 
      }); 

      $(".block-category .sub-menu > li").each( function(){
        if($(this).hasClass('active')){
          $(this).parent().addClass('active');
        }
      });

      $('.dropdown-toggle').click(function() {
        $('.dropdown-content').removeClass('active');
        $(this).next().toggleClass('active');    
        return false;              
      });   
    },



    /* Check Item Mini Cart */
    checkItemsInMiniCart: function() {
      if($('.mini-cart .mini-products-list').children().length > 0) {
        $('.mini-cart').addClass('hasItem');          
      } else{
        $('.mini-cart').removeClass('hasItem'); 
      }
    },

    /* Mini Cart Click to Show */
    initDropDownCart: function() {      
      $('.dropdow .cartCount').click(function() {
        $(this).parent('.topCart').toggleClass('active');
      });            
      engo.checkItemsInMiniCart();

      $('.mini-cart .btn-remove').click(function(event) {       
        event.preventDefault();
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);
        Shopify.removeItem(productId, function(cart) {
          doUpdateMiniCart(cart);       
        });
      });
    },



    /* ------------------------------- */
    /* Product detail - Add to cart */

    initProductAddToCart: function() {
      $('#product-addTocart').click(function(event) {

        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {
          var variant_id = $('#AddToCartForm select[name=id]').val();
          if (!variant_id) {
            variant_id = $('#AddToCartForm input[name=id]').val();
          }
          var quantity = $('#AddToCartForm input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }
          var title = $('h1.product-name').html();
          var image = $('#ProductPhotoImg').attr('src');

          doAjaxAddToCart(variant_id, quantity, title, image);

        }

        return false;
      });

    },

  }

  })(jQuery);